import { useEffect } from 'react';

type AppRefreshHandler = () => Promise<unknown> | unknown;

const refreshHandlers = new Set<AppRefreshHandler>();

export function registerAppRefreshHandler(handler: AppRefreshHandler) {
  refreshHandlers.add(handler);

  return () => {
    refreshHandlers.delete(handler);
  };
}

export async function runAppRefreshHandlers() {
  await Promise.all([...refreshHandlers].map(handler => handler()));
}

export function useAppRefreshHandler(handler: AppRefreshHandler) {
  useEffect(() => registerAppRefreshHandler(handler), [handler]);
}
